import { useState, useEffect } from "react";
import { Button, Space, Tag } from "antd";
import { InfoOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import BotonIrKiconex from "../BotonIrKiconex/BotonIrKiconex.jsx";
import { withLocale } from "../../l10n/index.jsx";
import DataTable from "../DataTable/index.js";
import { GetColumnLiteralSearchProps } from '../../utils/functions.jsx';
import { formatDate, compareDates } from '../../utils/dates';
import withNavigation from '../hooks/withNavigation.jsx';
import service from "../../services/Service.js";

function DevicesList({ lang, navigate }) {

  const [botonDisabled, setBotonDisabled] = useState(true);
  const [selectedUUID, setSelectedUUID] = useState("");
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchDevices = async () => {
      setLoading(true);
      try {
        const res = await service.get('devices');
        setDevices(res?.data?.ok ? res.data.data : []);
      } catch (err) {
        console.error('Error al obtener dispositivos:', err);
        setDevices([]);
      } finally {
        setLoading(false);
      }
    };
    fetchDevices();
  }, []);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setBotonDisabled(false);
      setSelectedUUID(selectedRows[0].uuid);
    }
  };

  const columns = [
    {
      title: lang.handle('Nombre'),
      dataIndex: "name",
      sorter: (a, b) => String(a.name || '').localeCompare(String(b.name || '')),
      ...GetColumnLiteralSearchProps('name', lang)
    },
    {
      title: lang.handle('Descripción'),
      dataIndex: "description",
      sorter: (a, b) => String(a.description || '').localeCompare(String(b.description || '')),
      ...GetColumnLiteralSearchProps('description', lang)
    },
    {
      title: lang.handle('UUID placa'),
      dataIndex: "device_uuid",
      ...GetColumnLiteralSearchProps('device_uuid', lang)
    },
    {
      title: lang.handle('Estado instalación'),
      dataIndex: ["status", "link", "detected"],
      filters: [
        { text: lang.handle('Conectada'), value: true },
        { text: lang.handle('Desconectada'), value: false },
      ],
      onFilter: (value, record) => {
        const valueCompare = record.status.link.detected ?? false;
        return valueCompare.toString().indexOf(value) === 0
      },
      render: function (data) {
        if (data === true) {
          return <Tag color="green"> {lang.handle('Conectada')} </Tag>;
        } else {
          return <Tag color="red"> {lang.handle('Desconectada')} </Tag>;
        }
      },
    },
    {
      title: lang.handle('Habilitación'),
      dataIndex: "enabled",
      render: function (data) {
        if (data === true) {
          return <Tag color="green"> {lang.handle('Habilitada')} </Tag>;
        } else {
          return <Tag color="red"> {lang.handle('Deshabilitada')}</Tag>;
        }
      },
      filters: [
        { text: lang.handle('Habilitada'), value: true },
        { text: lang.handle('Deshabilitada'), value: false },
      ],
      onFilter: (value, record) =>
        record.enabled.toString().indexOf(value) === 0,
    },
    {
      title: lang.handle('Caducidad suscripción'),
      dataIndex: "subscription_expiry",
      sorter: (a, b) => compareDates(a.subscription_expiry, b.subscription_expiry),
      render: function (value) {
        if (!value) return '-';
        const isExpired = dayjs(value).isBefore(dayjs(), 'day');
        return (
          <span style={isExpired ? { color: 'red' } : undefined}>
            {formatDate(value)}
          </span>
        );
      },
    },
  ];

  const detallesPlaca = () => {
    navigate(`/devices/details/${selectedUUID}`);
  };

  return (
    <div>
      <DataTable
        rowSelection={{
          type: "radio",
          ...rowSelection,
        }}
        columns={columns}
        rowKey="device_uuid"
        dataSource={devices}
        loading={loading}
      />
      <div className="button-panel">
        <Space>
          <Button
            type="primary"
            icon={<InfoOutlined />}
            disabled={botonDisabled}
            onClick={detallesPlaca}
          >
            {lang.handle('Detalles')}
          </Button>
          <BotonIrKiconex
            disabled={botonDisabled}
            uuid={selectedUUID}
          />
        </Space>
      </div>
    </div>
  );
}

export default withLocale(withNavigation(DevicesList));
